import "./fieldBtn.scss";

const FieldButton = ({ onClick, children }) => (
  <button className="clear-button" onClick={onClick}>
    {children}
  </button>
);

export default FieldButton;
